// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"8dea59ab","732":"c2228cbd"}[chunkId] + ".chunk.js";
};